import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GitaHeader } from '../components/GitaHeader/GitaHeader';
import { setAboutDocumentTitle } from '../utils/seo';
import '../App.css';
import './About.css';

export default function About() {
  useEffect(() => {
    setAboutDocumentTitle();
  }, []);

  return (
    <div className="about-page gita-app-root">
      <div className="gita-header-wrap no-print" style={{ padding: '0 16px' }}>
        <GitaHeader showReaderControls={false} />
      </div>
      <main className="about-main" id="main-content">
        <h1>About The Gita</h1>
        <p className="about-lead">
          This site is a <strong>free</strong> reader for the <strong>Bhagavad Gita</strong> — offered to help
          more people discover, read, and reflect on the text. There are no ads and no paywalls.
        </p>

        <section aria-labelledby="what-youll-find-heading">
          <h2 id="what-youll-find-heading">What you&apos;ll find</h2>
          <ul>
            <li>Chapters and verses (ślokas) with meaning, commentary, and synonyms where available</li>
            <li>Audio for verses and meanings (where provided)</li>
            <li>
              An optional{' '}
              <a href="https://ux.thegita.org.in" target="_blank" rel="noopener noreferrer">
                AI study assistant
              </a>{' '}
              — use it as a learning aid; always cross-check with the text and trusted teachers or
              commentaries.
            </li>
          </ul>
        </section>

        <section aria-labelledby="sources-heading">
          <h2 id="sources-heading">Sources &amp; API</h2>
          <p>
            Content is served from{' '}
            <a href="https://api.thegita.org.in" target="_blank" rel="noopener noreferrer">
              api.thegita.org.in
            </a>
            . If you are building your own project, the same API may be available for reference — see the
            API site for details.
          </p>
        </section>

        <section aria-labelledby="privacy-heading">
          <h2 id="privacy-heading">Privacy</h2>
          <p>
            This reader keeps things simple: we don&apos;t add third-party analytics in this app by default.
            If that changes, we&apos;ll note it here.
          </p>
        </section>

        <p className="about-back">
          <Link to="/read/1/1">← Back to reading</Link>
        </p>
      </main>
    </div>
  );
}
